import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    subscribers: [],
    isSubscribersLoading: false

}


export const getSubscribers = createAsyncThunk(
    'get_subscribers_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getSubscribersStart());
            const response = await axios.get(`/forms/get_subscribers.php`)
            console.log('response of subscribers', response?.data?.data)
            if (response?.data?.status == 'success') {

                dispatch(getSubscribersSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getSubscribersFailure(error.response.data.message))
        }
    }
)
export const addSubscriber = createAsyncThunk(
    "addsubscribers",
    async (data, { dispatch, rejectWithValue }) => {
        console.log('data os subscribersData ', data)
        try {
            dispatch(addSubscribersStart());
            const response = await axios.post(`/forms/add_subscribers.php`, data);
            dispatch(addSubscribersSuccess(response.data));
            if (response?.data?.status == 'success') {
                dispatch(getSubscribers())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addSubscribersFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);

const subscribersSlice = createSlice({
    name: 'subscribers',
    initialState,
    reducers: {
        getSubscribersStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getSubscribersSuccess(state, action) {

            state.subscribers = action.payload;
            state.isLoading = false;
        },
        getSubscribersFailure(state, action) {
            state.subscribers = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addSubscribersStart(state) {
            state.isSubscribersLoading = true;
            state.error = null;
        },
        addSubscribersSuccess(state, action) {
            state.user = action.payload;
            state.isSubscribersLoading = false;
        },
        addSubscribersFailure(state, action) {
            state.error = action.payload;
            state.isSubscribersLoading = false;
        },


    }
})

export const { getSubscribersSuccess, getSubscribersStart, getSubscribersFailure, addSubscribersStart, addSubscribersSuccess, addSubscribersFailure } = subscribersSlice.actions;

export default subscribersSlice.reducer;